import { expVal } from '@confluence/feature-experiments';
import { getBrowserTabId } from '@confluence/graphql/entry-points/getBrowserTabId.ts';

type ShouldSkipOwnPubSubEventArgs = {
	accountId?: string | null;
	currentUserId?: string | null;
	originTabId?: string | null;
};

export const shouldSkipOwnPubSubEvent = ({
	accountId = null,
	currentUserId = null,
	originTabId = null,
}: ShouldSkipOwnPubSubEventArgs): boolean => {
	if (expVal('cc_use_browser_tab_id', 'isEnabled', false)) {
		return originTabId === getBrowserTabId();
	}

	return !!accountId && accountId === currentUserId;
};
